import { useReduxSelector } from "../../redux/hooks/hooks";
import * as jwt from "jwt-decode";

export default function useTenantUrl(): string {
    const revToken = useReduxSelector((state: any) => state.auth.user?.access_token);
    // jwt-decode can be exported in different shapes; support both jwt.jwtDecode and default function
    let decoded: any = null;
    if (revToken) {
        try {
            // @ts-ignore
            if ((jwt as any).jwtDecode) decoded = (jwt as any).jwtDecode(revToken);
            else decoded = (jwt as any)(revToken);
        } catch (e) {
            decoded = null;
        }
    }
    return decoded?.tenantUrl || "";
}
